import { FunctionComponent } from "react";
import NAV from "../components/NAV";

const Lesson1: FunctionComponent = () => {
  return (
    <div className="relative bg-gray-100 w-full overflow-hidden flex flex-col items-center justify-center pt-[2.69rem] px-[2.69rem] pb-[6.25rem] box-border gap-[6.88rem] text-left text-[1.56rem] text-darkgray font-nunito">
      <NAV dimensionCode="/nav@2x.png" navIconFlexShrink="unset"/>
      <div className="self-stretch flex flex-row items-center justify-between">
      <a className="cursor-pointer text-darkgray no-underline" href={"https://unityacademy.io/dashboard"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Back
          </b>
        </div>
        </a>
        <div className="self-stretch flex-1 flex flex-col items-center justify-center text-center text-[2.81rem] text-white">
          <b className="self-stretch relative leading-[100%]">
            Healthy Lifestyle
          </b>
        </div>
        <a className="cursor-pointer text-darkgray no-underline" href={"/lesson2"}>
        <div className="flex-1 rounded-32xl bg-gainsboro-200 box-border h-[3.5rem] flex flex-col items-center justify-center py-[0.69rem] px-[3rem] max-w-[12.5rem] border-[1px] border-solid border-gray-300">
          <b className="relative inline-block w-[3.75rem] h-[2.06rem] shrink-0">
            Next
          </b>
        </div></a>
      </div>
      <div className="self-stretch flex flex-col items-center justify-center gap-[4.63rem] text-justify text-gainsboro-100 font-dm-sans">
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem] whitespace-pre-wrap">
          <p className="m-0">
            <b className="text-[1.88rem] font-dm-sans">
              <span className="text-white">The Wheel Of Life</span>
            </b>
            <span>
              <b className="text-[1.88rem] font-dm-sans">{`:  `}</b>
              <span>
                shows a clear representation of an individual's circumstances.
                It gives insight into how to bring balance into one's life. By
                making this balance a reality, happiness, and success will
                pre-flow. The Wheel Of Life focuses on eight components.
              </span>
            </span>
          </p>
          <p className="m-0">
            <span>
              <span>&nbsp;</span>
            </span>
          </p>
          <ul className="m-0 pl-[2.06rem]">
            <li className="mb-[0rem]">
              <span>
                <span>{`Work & career`}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Finance</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Health</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Family & friends`}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Love & romance`}</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>Personal growth</span>
              </span>
            </li>
            <li className="mb-[0rem]">
              <span>
                <span>{`Relaxation & fun`}</span>
              </span>
            </li>
            <li>
              <span>
                <span>Social contribution</span>
              </span>
            </li>
          </ul>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-white">
            <b>History</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The Wheel Of Life is a teaching from Tibetan Buddhism that brings
            together various Buddhist concepts. However, the Wheel of Life
            should not be confused with the Tibetan version, which focuses more
            on awareness of personal mental states. Remember, the life wheel you
            will be dealing with relates to balance, happiness, and success.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-white">
            <b>Illustration</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            The Wheel Of Life is depicted as a circle. This circle is divided
            into eight points. Each point represents one can of the eight parts.
            You can download the image listed below so you can use it later.
          </p>
        </div>
        <img
          className="relative w-[83.5rem] h-[46.93rem] object-cover"
          alt=""
          src="/1@2x.png"
        />
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0">
            You can fill in your own Wheel Of Life by asking yourself certain
            questions on each topic. Examples of questions you can use are:
          </p>
          <p className="m-0">How satisfied am I in this area?</p>
          <p className="m-0">
            How much happiness am I experiencing in this area?
          </p>
          <p className="m-0">How much energy do I get from this area?</p>
          <p className="m-0">How much time do I spend in this area?</p>
          <p className="m-0">
            Make a list of all topics and about 5 questions per topic. Give
            answers by writing down a mark between 1 and 10 after each question.
            Then calculate the average mark for each topic. Mark the grade that
            comes out of this in the wheel of life. An example is shown below.
          </p>
        </div>
        <div className="self-stretch relative tracking-[0.02em] leading-[2rem]">
          <p className="m-0 text-white">
            <b>Balance</b>
          </p>
          <p className="m-0">&nbsp;</p>
          <p className="m-0">
            Now that you have a clear picture of what your Wheel Of Life looks
            like, you can see if your life is in balance. If all grades are a
            pass and your circle is complete, you are well on your way. However,
            your circle may also show peaks and valleys. If this is so, what
            feeling do you get from this? Would you like to improve the lower
            scores?
          </p>
          <p className="m-0">
            You can find balance by lifting all grades to the same level. When
            you have already come full circle, you can try to score even higher.
            The goals you will set later in this guide can be based, among other
            things, on your Wheel Of Life. It's a great tool to use during, and
            after the process of becoming happy and successful.
          </p>
        </div>
      </div>
      <a className="cursor-pointer text-darkgray no-underline" href={"/lesson2"}>
        <div className="rounded-32xl bg-gainsboro-200 box-border w-[25rem] flex flex-col items-center justify-center pt-[0.69rem] px-[3rem] pb-[1rem] max-w-[31.25rem] text-center text-[1.88rem] border-[1px] border-solid border-gray-300">
          <b className="self-stretch relative">Next Chapter</b>
        </div>
      </a>
    </div>
  );
};

export default Lesson1;
